import { inject, observer } from "mobx-react";
import AgGrid from "../../../common/components/ag-grid/ag-grid";
import React from "react";
import moment from "moment";
import CheckboxRenderer from "../../../common/CheckboxRenderer";
import SmartSelectClearable from "../../../common/SmartSelectClearable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NumericCellEditorAllowNegative } from "../../../common/NumericCellEditorAllowNegative";
import RestEndPoint from "../../../common/RestEndPoint";
import "./gainloss-subSystemVariance-screen.scss";
import Select from "react-select";
import {
  faFileExport,
  faSave,
  faSearch,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import commonstore from "../../../common/commonstore";
import {
  DateFormatter,
  DateTimeFormatter,
  MMYYYYFormatter,
} from "../../../common/DateFormatterWithZone";
import {
  DecimalFormatter2Digits,
  DecimalFormatter4Digits,
  formatDecimalValue,
} from "../../../common/NumberFormatter";
import { Datepicker } from "../../../common/Datepicker";
import gainLossSubSystemVarianceScreenStore from "../store/gain-loss-subSystemVariance-screen--store";
import AuditModal from "./gainloss-subSystemVariance-screen-audit-modal";
import "./ginloss-subSystemVariance-screen.scss";
import { ColorFormatter } from "../../../common/ColorFormatter";
import { ALL_DISTRICT_OR_DIVISION } from "../../../constants/common"
@inject("GainLossSubSystemVarianceDataStore")
@observer
class GainLossSubSystemVarianceScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gridOptions: {
        newRowNotSaved: false,
        rowSelection: "multiple",
        singleClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        enableRangeSelection: true,
        rowGroupPanelShow: "always",
        suppressContextMenu: false,
        getRowStyle: this.getRowStyleScheduled,
        statusBar: {
          statusPanels: [
            {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left",
            },
            {
              statusPanel: "agAggregationComponent",
              statusPanelParams: {
                aggFuncs: ["avg", "count", "min", "max", "sum"],
              },
            },
          ],
        },
        sideBar: {
          toolPanels: [
            {
              id: "columns",
              labelDefault: "Columns",
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
            },
          ],
          showToolPanel: false,
        },
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true,
        },
        frameworkComponents: {
          SmartSelectClearable: SmartSelectClearable,
          booleanCellEditor: CheckboxRenderer,
          dateFormatter: DateFormatter, //for effective start date
          dateTimeFormatter: DateTimeFormatter, //for audit info
          monthYearFormatter: MMYYYYFormatter,
          datePicker: Datepicker,
          decimalFormatter: DecimalFormatter2Digits, //for 3 digits round off materiality)
          decimalFormatter3Digits: DecimalFormatter4Digits, //for 4 digit round off (tolerance and offset)
          ColorFormatter: ColorFormatter,
        },
      },
      jurisdiction: "",
      division: "",
      productionMonth: "",
      currentColDef: [],

      screenrowData: [],
      editRowData: "",
      rowSelected: false,

      jurisdictionTxt: "select jurisdiction",
      monthYearTxt: "",
      isSubmitting: false,
      currentColumnDef: [],
      readOnlyRole: false,
      selectedData: [],
      subsystemlected: "",
      selectedRowsCount: 0,

      availableReferenceData: [],
      copiedEffectiveStartDate: "",
      copiedSubSystem: "",

      isCopyRow: false,
      editRowData: "",
      isFormVisible: false,
      formRowData: [],
    };
  }
  getContextMenuItems = (e) => {
    const { CommonStore, GainLossSubSystemVarianceDataStore } = this.props;
    var result = [
      {
        name: "Show Audit Data",
        action: async () => {
          const auditData =
            await GainLossSubSystemVarianceDataStore.getAuditData(
              CommonStore,
              e.node.data
            );
          GainLossSubSystemVarianceDataStore.setAuditPopUp(true);
        },
      },
    ];
    return result;
  };
  customComparator(valueA, valueB) {
    return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
  }
  getShowAuditPopUp = () => {
    const { GainLossSubSystemVarianceDataStore } = this.props;
    const { showAuditPopUp } = GainLossSubSystemVarianceDataStore;
    return showAuditPopUp;
  };
  setColumnDef = async () => {
    const { CommonStore, GainLossSubSystemVarianceDataStore } = this.props;
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    await GainLossSubSystemVarianceDataStore.setColumnDef(
      currentScreen,
      CommonStore
    );
  };
  getCurrentScreenChildren = () => {
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreenChildren = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.parent === parentScreenName
    );

    return currentScreenChildren;
  };
  getCurrentScreenChildrenByNm = (screenName) => {
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreenChildren = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.parent === parentScreenName && x.screen.name == screenName
    );

    return currentScreenChildren;
  };
  handleJurisdictionChange = async (e) => {
    this.state.jurisdiction = e.value;
    const { GainLossSubSystemVarianceDataStore } = this.props;
    GainLossSubSystemVarianceDataStore.resetSubSystemVarianceData();

    GainLossSubSystemVarianceDataStore.selectedJurisdiction =
      this.state.jurisdiction;
    this.state.division = { value: "", label: "Select..." };

    this.HideColumns();
    this.RenameColumnNames();
    await GainLossSubSystemVarianceDataStore.getEntityName();
  };
  handleDivisionChange = async (e) => {
    this.state.division = { value: e.value, label: e.value };
    const { GainLossSubSystemVarianceDataStore } = this.props;
    GainLossSubSystemVarianceDataStore.resetSubSystemVarianceData();

    GainLossSubSystemVarianceDataStore.selectedDivision = this.state.division;
  };
  handleProductionMonthChange = async (e) => {
    const { GainLossSubSystemVarianceDataStore } = this.props;
    GainLossSubSystemVarianceDataStore.resetSubSystemVarianceData();

    GainLossSubSystemVarianceDataStore.selectedProductionMonth = {
      value: e.value,
      label: e.label,
    };
    this.setState({ newRowNotSaved: false });
    this.setState({ isCopyRow: false });
    this.setState({ productnewRowNotSaved: false });
    this.setState({ rowSelected: false, fileNameExcel: null });
  };
  getSubSystemVarianceData = async () => {
    this.setState({ rowSelected: false, editRowData: "" });
    const { CommonStore, GainLossSubSystemVarianceDataStore } = this.props;
    const { jurisdictionTxt } = this.state;
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    await GainLossSubSystemVarianceDataStore.getScreenData(CommonStore);
  };

  getKeyColumnName = () => {
    const { screenColumns } = this.getCurrentScreen();
    const keyColumn = screenColumns.find((x) => x.isKey);
    let keyColumnName = keyColumn ? keyColumn.name : "id";

    return keyColumnName;
  };

  selectNode(nodeIndex) {
    let node = this.state.gridOptions.api.getDisplayedRowAtIndex(nodeIndex);
    node.setSelected(true);
  }

  getCurrentScreen = () => {
    const screenName = this.props.path.split("/").pop();
    const currentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === screenName
    );
    return currentScreen;
  };

  getProductionMonths = () => {
    const { GainLossTransactionScreenStore } = this.props;
    const { productionMonthData, selectedProductionMonth } =
      GainLossTransactionScreenStore;
    const c = selectedProductionMonth;
    return productionMonthData;
  };

  setjurisdictionOptions = () => {
    const userRoles = RestEndPoint.getCurrentUserRoles();
    if (userRoles.includes("GainLossAdminRole")) {
      return [
        { value: "Plains - North", label: "Plains - North" },
        { value: "Plains - South", label: "Plains - South" },
      ];
    } else if (
      userRoles.includes("GainLossNorthDataEntryRole") ||
      userRoles.includes("GainLossNorthDistrictSignOffRole")
    ) {
      return [{ value: "Plains - North", label: "Plains - North" }];
    } else if (
      userRoles.includes("GainLossSouthDataEntryRole") ||
      userRoles.includes("GainLossSouthDistrictSignOffRole")
    ) {
      return [{ value: "Plains - South", label: "Plains - South" }];
    } else {
      return [];
    }
  };
  HideColumns = () => {
    if (this.state.jurisdiction === "Plains - South") {
      this.state.gridOptions.columnApi.setColumnVisible(
        [
          "offset",
          "afterShrinkageGainLoss",
          "afterShrinkageGainLossPercent",
          "blendingShrinkage",
          "unidentifiedGainLoss",
          "unidentifiedGainLossPercent",
          "material",
        ],
        false
      );
      this.state.gridOptions.columnApi.setColumnVisible(
        "blendingShrinkage",
        false
      );
      this.state.gridOptions.columnApi.setColumnVisible(
        "unidentifiedGainLoss",
        false
      );
      this.state.gridOptions.columnApi.setColumnVisible(
        "unidentifiedGainLossPercent",
        false
      );
      this.state.gridOptions.columnApi.setColumnVisible("offset", false);
      this.state.gridOptions.columnApi.setColumnVisible("material", false);
      this.state.gridOptions.columnApi.setColumnVisible(
        "afterShrinkageGainLossPercent",
        false
      );
      this.state.gridOptions.columnApi.setColumnVisible(
        "afterShrinkageGainLoss",
        false
      );
      this.state.gridOptions.columnApi.setColumnVisible("subSystem", false);
      this.state.gridOptions.columnApi.setColumnVisible("materiality", false);
    } else if (this.state.jurisdiction === "Plains - North") {
      this.state.gridOptions.columnApi.setColumnVisible(
        [
          "offset",
          "afterShrinkageGainLoss",
          "afterShrinkageGainLossPercent",
          "blendingShrinkage",
          "unidentifiedGainLoss",
          "unidentifiedGainLossPercent"
        ],
        true
      );
      this.state.gridOptions.columnApi.setColumnVisible(
        "blendingShrinkage",
        true
      );
      this.state.gridOptions.columnApi.setColumnVisible(
        "unidentifiedGainLoss",
        true
      );
      this.state.gridOptions.columnApi.setColumnVisible(
        "unidentifiedGainLossPercent",
        true
      );
      this.state.gridOptions.columnApi.setColumnVisible("offset", false);
      this.state.gridOptions.columnApi.setColumnVisible("material", false);
      this.state.gridOptions.columnApi.setColumnVisible(
        "afterShrinkageGainLossPercent",
        true
      );
      this.state.gridOptions.columnApi.setColumnVisible(
        "afterShrinkageGainLoss",
        true
      );
      this.state.gridOptions.columnApi.setColumnVisible("subSystem", true);
      this.state.gridOptions.columnApi.setColumnVisible("materiality", false);
    }
  };

  RenameColumnNames = () => {
    if (this.state.jurisdiction === "Plains - South") {
      const newColDef = this.state.gridOptions.columnDefs;
      newColDef.forEach(function (colDef) {
        if (colDef.field === "withinTolerance") {
          colDef.headerName = "Tolerance";
        } else if (colDef.field === "throughput") {
          colDef.headerName = "Throughput - (bbl)";
        } else if (colDef.field === "gainLoss") {
          colDef.headerName = "Gain/(Loss) - (bbl)";
        } else if (colDef.field === "division") {
          colDef.headerName = "Division";
        }
      });
      this.state.gridOptions.api.setColumnDefs(newColDef);
    } else if (this.state.jurisdiction === "Plains - North") {
      const newColDef = this.state.gridOptions.columnDefs;
      newColDef.forEach(function (colDef) {
        if(colDef.field === "materiality" && !colDef.headerName.includes('$')){
          colDef.headerName = `${colDef.headerName} $`
        }
        if (colDef.field === "withinTolerance") {
          colDef.headerName = "Tolerance";
        } else if (colDef.field === "throughput") {
          colDef.headerName = "Throughput - (m3)";
        } else if (colDef.field === "gainLoss") {
          colDef.headerName = "Gain/(Loss) - (m3)";
        } else if (colDef.field === "division") {
          colDef.headerName = "District";
        }
      });
      this.state.gridOptions.api.setColumnDefs(newColDef);
    }
  };
  render() {
    const {
      division,
      headerDetails,
      GainLossSubSystemVarianceDataStore,
      screenRowData,
      rowData,
      hasScreenData,
      screenColumnDefinitions,
      selectedData,
    } = this.props.GainLossSubSystemVarianceDataStore;
    const parentScreen = this.getCurrentScreenParent();
    var districtData = [];
    Object.values(division).forEach((value) => {
      districtData.push({
        value: value,
        label: value,
      });
    });
    // option "All" for district/division
    if(districtData?.length){
      districtData.unshift(ALL_DISTRICT_OR_DIVISION)
    }

    let rowdata = screenRowData.SubSystemVarianceData;
    if (
      this.state.jurisdiction === null ||
      this.state.jurisdiction === undefined ||
      this.state.jurisdiction === ""
    ) {
      rowdata = [];
    }
    const { productionMonthData, selectedProductionMonth } =
      this.props.GainLossSubSystemVarianceDataStore;
    return (
      <div className="col-md-12 transactions-screen-container">
        <div className="row">
          <div className="col-md-12 transactions-screen-container">
            <div className="container cb-title-container">
              <h3 className="cb-title">{parentScreen.screen.title}</h3>
            </div>
            <div className="col-md-12 filters-container">
              <div className="transaction-filter-container">
                <div className="field-label">{"Jurisdiction"}</div>
                <div className="col-md-8">
                  <Select
                    options={this.setjurisdictionOptions()}
                    value={this.jurisdiction}
                    onChange={this.handleJurisdictionChange}
                  />
                </div>
              </div>
              <div className="transaction-filter-container">
                <div className="field-label">{"Division/District"}</div>
                <div className="col-md-8">
                  <Select
                    options={districtData}
                    value={this.state.division}
                    onChange={this.handleDivisionChange}
                  />
                </div>
              </div>
              <div className="transaction-filter-container">
                <div className="field-label">{"Production Month"}</div>
                <div className="col-md-8">
                  <Select
                    options={productionMonthData}
                    value={selectedProductionMonth}
                    onChange={this.handleProductionMonthChange}
                  />
                </div>
              </div>

              <div className="transaction-filter-container">
                <div className="col-md-8">
                  <button
                    type="search"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    disabled={
                      this.state.jurisdiction === "" ||
                      this.state.division.value === ""
                    }
                    onClick={this.getSubSystemVarianceData}
                  >
                    <FontAwesomeIcon icon={faSearch} />
                    Search
                  </button>{" "}
                </div>
              </div>
            </div>

            <div>
              <div className="row">
                {rowData && (
                  <AgGrid
                    gridID={"SubSystemVarianceScreenData"}
                    gridOptions={this.state.gridOptions}
                    columnDefs={
                      screenColumnDefinitions.GainLossSubSystemVarianceScreen
                    }
                    rowData={rowdata}
                    onCellValueChanged={this.onCellValueChanged.bind(this)}
                    getContextMenuItems={this.getContextMenuItems.bind(this)}
                  />
                )}
              </div>
              <div className="row btn-toolbar pull-right">
                <button
                  type="save"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  onClick={this.saveSubSystemVarianceData}
                  disabled={rowData.length <= 0}
                >
                  <FontAwesomeIcon icon={faSave} />
                  Save
                </button>
                <button
                  type="refresh"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  onClick={this.refreshData}
                >
                  <FontAwesomeIcon icon={faSync} />
                  Refresh / Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  disabled={rowData.length == 0}
                  onClick={this.exportToExcel}
                >
                  <FontAwesomeIcon icon={faFileExport} />
                  Export
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.getShowAuditPopUp() && <AuditModal />}
      </div>
    );
  }

  saveSubSystemVarianceData = async () => {
    const { CommonStore, GainLossSubSystemVarianceDataStore } = this.props;
    await gainLossSubSystemVarianceScreenStore.saveData(CommonStore);

    if (GainLossSubSystemVarianceDataStore.SubSystemVarianceDataSaved) {
      await this.getSubSystemVarianceData();
      this.setState({ newRowNotSaved: false });
      this.setState({ isCopyRow: false });
      this.setState({ selectedRowsCount: 0 });
    }
    this.state.screenrowData = [];
  };

  onCellValueChanged = function (e) {
    const currentUser = RestEndPoint.getCurrentUserName();
    const { selectedData } = this.props.GainLossSubSystemVarianceDataStore;
    const keyColumnName = this.getKeyColumnName();
    const mstTime = new Date().toLocaleString("en-US", {
      timeZone: "America/Denver",
    });
    if (e.oldValue != e.newValue && e.newValue !==null) {
      const updatedRow = this.state.gridOptions.api.getSelectedRows();
      e.data["lastSavedBy"] = currentUser;
      e.data["lastSavedDateTime"] = mstTime;
      updatedRow[0] = e.data;
      const toUpdateRow = updatedRow[0];
      selectedData.push(toUpdateRow);
      this.state.gridOptions.api.refreshCells();
    } else {
        e.node.setDataValue(e.colDef.field, e.oldValue);
    }
  };
  formatExportValues = (params) => {
    switch (params?.column?.colId) {
      case "sourceSystemLoadDateTime":
      case "lastSavedDateTime":
        return params?.value
          ? moment(params?.value).format("MM/DD/YYYY h:mm a")
          : "";
      case "productionMonth":
      case "productionDate":
        return params?.value ? moment(params?.value).format("MM/YYYY") : "";

      default:
        return params?.value;
    }
  };
  exportToExcel = () => {
    const parentScreenName = this.props.path.split("/").pop();
    let params = {
      allColumns: false,
      onlySelected: false,
      onlySelectedAllPages: false,
      shouldRowBeSkipped: false,
      skipFooters: false,
      skipGroups: true,
      skipHeader: false,
      skipPinnedTop: false,
      skipPinnedBottom: false,
      fileName: parentScreenName,
    };
    var today = new Date();
    const formattedDate = moment(today).format("YYYYMMDDhhmmss");
    const currentSheet = parentScreenName;
    let fileNameExcelExport =
      currentSheet + "_Export_All_" + formattedDate + "";

    this.state.gridOptions.api.exportDataAsExcel({
      fileName: fileNameExcelExport,
      sheetName: currentSheet,
      processCellCallback: this.formatExportValues,
    });
  };
  componentDidMount = async () => {
    await this.refreshHeader();
    await this.setColumnDef();
    //await this.refreshData();
    await this.loadProductionMonths();
  };
  loadProductionMonths = async () => {
    await this.props.GainLossSubSystemVarianceDataStore.setProductionMonths();
  };
  refreshData = async () => {
    this.setState({ newRowNotSaved: false });
    this.setState({ isCopyRow: false });
    this.setState({ productnewRowNotSaved: false });
    this.setState({ rowSelected: false, fileNameExcel: null });
    this.setState({ selectedRowsCount: 0 });
    await this.getSubSystemVarianceData();
  };
  refreshHeader = async () => {
    const { CommonStore, GainLossSubSystemVarianceDataStore } = this.props;
    await GainLossSubSystemVarianceDataStore.getHeaderData(CommonStore);
  };
  getCurrentScreenParent = () => {
    const parentScreenName = this.props.path.split("/").pop();
    const parentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === parentScreenName
    );

    return parentScreen;
  };
}
export default GainLossSubSystemVarianceScreen;
